export default class Ticket {
    numbers?: number[];

    constructor(numbers?: number[]) {
        if (numbers == undefined) {
            numbers = []
        }
        this.numbers = numbers
    }
}